import { QueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";

/** Mesmo número de novas tentativas do padrão do React Query. */
const MAX_QUERY_RETRIES = 3;

/**
 * 403 é resposta definitiva: o perfil não tem a chave (SA-1352). Repetir só
 * multiplica a request negada, e cada 403 ainda faz o interceptor do axios
 * refazer `/user/me` e os acessos. O resto segue o padrão (3 tentativas).
 */
export const shouldRetryQuery = (failureCount: number, error: unknown) => {
  if (isAxiosError(error) && error.response?.status === 403) return false;
  return failureCount < MAX_QUERY_RETRIES;
};

/**
 * Instância única do React Query da aplicação. Mora num módulo, e não dentro
 * do `AppProvider`, para quem não é componente (o interceptor de 403 do axios)
 * invalidar queries sem depender de hook.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: shouldRetryQuery,
    },
  },
});
